import "../PractiseAssessment/practiseAssessment.css";
import axios from "axios";
import PropTypes from "prop-types";
import { useState, useEffect, useMemo } from "react";

import Dropdown from "react-bootstrap/Dropdown";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";

import TestQuestion from "../Questions/TestQuestions/Question";

import LeftArrow from "../../images/LeftArrow";
import RightArrow from "../../images/RightArrow";
import AuthorQues from "../AuthorQues/AuthorQues";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const Page_Limit = 5;

const CompentencyAssessment = ({
  sectionId,
  subjectId,
  chapterId,
  questions,
  setQuestions,
}) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [authorQues, setAuthorQues] = useState(false);
  const [questionId,setQuestionId] = useState("");

  async function fetchQuestions() {
    if (!chapterId || loading) return;
    setLoading(true);
    const authToken = localStorage.getItem("authToken");
    axios
      .get(
        `${process.env.REACT_APP_ORIGIN}/api/v1/competency-questions?chapterId=${chapterId}`,
        {
          headers: {
            token: authToken,
          },
        }
      )
      .then((res) => {
        setQuestions(res.data.data.questions);
      })
      .catch((err) => {
        alert(err.message);
      })
      .finally(() => setLoading(false));
  }

  const deleteQuestion = async (id) => {
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_ORIGIN2}/api/v1/competency-questions/${id}`,
        {
          headers: {
            token: authToken,
          },
        }
      );
      if (response.data.status === "success") {
        const newQuestion = questions.filter((ques) => ques._id !== id);
        setQuestions(newQuestion);
      }
    } catch (error) {
      if (error.response.data.status === "fail") {
        alert.error("Try Again.");
      } else {
        alert.error("Try Again.");
      }
    }
  };

  const syncQuestion = (question) => {
    if(!question) return;
    const questionIndex = questions.findIndex(q => q._id === question._id);
    if(question < 0) return;
    questions[questionIndex] = question;
    setQuestions([...questions]);
  }

  useEffect(() => {
    if (questions.length) return;
    fetchQuestions();
  }, [chapterId]);

  const totalPage = useMemo(() => {
    return Math.ceil(questions.length / Page_Limit);
  }, [questions]);

  const questionList = useMemo(() => {
    const startP = page - 1;
    return questions.slice(
      startP * Page_Limit,
      startP * Page_Limit + Page_Limit
    );
  }, [questions, page]);

  return (
    <div className="mx-auto">
      {loading ? (
        <div className="text-center">
          <CircularProgress style={{ color: "#FF075B", fontWeight: "600" }} />
        </div>
      ) : (
        <div>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "transparent !important",
              }}
            >
              <button
                onClick={() => setAuthorQues(!authorQues)}
                className="assessment-btn"
                style={{ margin: "0px !important" }}
              >
                <span>{authorQues ? "Show list" : "Create Question"}</span>
              </button>
              <div
                className="assesment_header__right"
                style={{ margin: "0px 0px 0px auto" }}
              >
                <div className="marks">
                  Q <br />
                  {questions.length}
                </div>
                
              </div>
            </div>
          </div>
          {authorQues ? (
            <AuthorQues
              selSubjectId={subjectId}
              selChapterId={chapterId}
              selTopicId={""}
              selSectionId={sectionId}
              setAuthorQues={setAuthorQues}
              index={0}
              initial={true}
              assessmentType="competency"
              topicsSel={[]}
              setArrQues={(question) => setQuestions([question, ...questions])}
            />
          ) : (
            <>
              <div className="slider">
                <LeftArrow
                  className="slider-img"
                  style={
                    page === 1 ? { visibility: "hidden" } : { display: "" }
                  }
                  onClick={async () => {
                    if (page <= 1) return;
                    setPage((prev) => prev - 1);
                  }}
                  color="#5ae893"
                />
                <div className="pageNumber">
                  {page}/{totalPage === 0 ? 1 : totalPage}
                </div>
                <RightArrow
                  className="slider-img floatright"
                  style={
                    page > totalPage
                      ? { visibility: "hidden" }
                      : { display: "block" }
                  }
                  onClick={async () => {
                    if (page >= totalPage) {
                      return;
                    }
                    setPage((prev) => prev + 1);
                  }}
                  color="#5ae893"
                />
              </div>

              {questionList.map((question, index) => {
                return (
                  <TestQuestion
                    key={index}
                    isPraticeSession
                    question={question}
                    index={index + 1}
                    page={page}
                    pageLimit={Page_Limit}
                    deleteQuestion={deleteQuestion}
                    setSelQuest={syncQuestion}
                    setQuestId={setQuestionId}
                  />
                );
              })}
            </>
          )}
        </div>
      )}
    </div>
  );
};
export default CompentencyAssessment;
